import { useEffect, useState } from "react";
import {
  eachDayOfInterval,
  lastDayOfQuarter,
  format,
  isWeekend,
} from "date-fns";
import { getUpcomingHolidays } from "@/lib/nagerdate/holidays";
import { Card } from "@/components/ui/card";

export function BusinessDaysLeftInQuarter() {
  const [businessdaysInQuarter, setBusinessdaysInQuarter] = useState<
    number | null
  >(null);

  const calculateAndSetBusinessdaysInQuarter = async () => {
    const days = await calculateBusinessdaysInQuarter();
    setBusinessdaysInQuarter(days);
  };

  useEffect(() => {
    calculateAndSetBusinessdaysInQuarter();
  }, []);

  if (businessdaysInQuarter === null) return null;

  return (
    <Card className="pl-3 pr-0 py-2">
      <div className="flex flex-row gap-2 items-center">
        <h1 className="text-3xl">{businessdaysInQuarter}</h1>
        <div className="max-w-24 leading-4 text-xs text-gray-500">
          business days left in quarter
        </div>
      </div>
    </Card>
  );
}

async function calculateBusinessdaysInQuarter() {
  const start = new Date();
  const end = lastDayOfQuarter(start);

  const daysLeftInQuarter = eachDayOfInterval({ start, end }).map((d) =>
    format(d, "yyyy-MM-dd")
  );

  const upcomingHolidays = await getUpcomingHolidays();
  const upcomingHolidayDays = new Set(upcomingHolidays.map((h) => h.date));

  const businessDaysLeftInQuarter = daysLeftInQuarter.filter(
    (d) => !isWeekend(d) && !upcomingHolidayDays.has(d)
  );

  return businessDaysLeftInQuarter.length;
}
